import PageLoaderService from '../ts/service/page-loader-service.ts';

PageLoaderService.init();

const serpDependencies = [
  'jrCommonDirective',
  'jrCommonService',
  'jrCommonController',
  'jrJobPreview',
  'jrAutocompleteEmail',
  'jrCookieConsent',
  'jrLocationInput',
  'jrProposal',
  'ngAnimate',
  'ngSanitize',
  'ui.bootstrap',
];

angular.module('jrJpp', serpDependencies, [
  '$interpolateProvider',
  function ($interpolateProvider) {
    $interpolateProvider.startSymbol('[[');
    $interpolateProvider.endSymbol(']]');
  },
]);
